import { render, staticRenderFns } from "./TableHistorisUser.vue?vue&type=template&id=42b5854a&scoped=true&"
import script from "./TableHistorisUser.vue?vue&type=script&lang=js&"
export * from "./TableHistorisUser.vue?vue&type=script&lang=js&"
import style0 from "./TableHistorisUser.vue?vue&type=style&index=0&id=42b5854a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b5854a",
  null
  
)

export default component.exports